import zappy from "@zappy-ride/library.react.components";
import { SmartPreloader } from "./SmartPreloader";

export * from "./SmartPreloader";

zappy.FactoryInstance.registerComponent(SmartPreloader);
